import { PipelineService } from '@app/assets/agent/agent.service';
import { CodeRepoService } from '@app/assets/code-repo/code-repo.service';
import { DataTableService } from '@app/assets/dataset/dataset.service';
import { GlobalFunctionService } from '@app/assets/function/function.service';
import { FoundationModelService } from '@app/assets/model/model.service';
import { PromptService } from '@app/assets/prompt/prompt.service';
import { RagService } from '@app/assets/rag/rag.service';
import { ReportsService } from '@app/assets/report/report.service';
import { ProjectRoleService } from '@app/auth/project-role/project-role.service';
import { UserService } from '@app/auth/user/user.service';
import { DeploymentService } from '@app/management/deployment/deployment.service';
import { RiskAssessmentService } from '@app/management/risk-assessment/risk-assessment.service';
import { AnnotationQueueService } from '@app/monitor/annotation-queue/annotation-queue.service';
import { MonitoringService } from '@app/monitor/monitoring/monitoring.service';
import { ApprovalWorkflowService } from '@app/shared/approval/approval-workflow.service';
import { OBJECTS } from '@app/shared/common/shared.constant';
import { PlatformSettingService } from '@app/shared/platform-setting/platform-setting.service';
import { GroupService } from '@app/shared/project/group.service';
import { FeedbackPortalService } from '@app/testing/feedback-portal/feedback-portal.service';
import { TestSessionService } from '@app/testing/test-session/test-session.service';

export const OBJECT_SERVICE_MAPPER = {
    [OBJECTS.DATA_TABLE]: DataTableService,
    [OBJECTS.GLOBAL_FUNCTION]: GlobalFunctionService,
    [OBJECTS.USER]: UserService,
    [OBJECTS.PROJECT_ROLE]: ProjectRoleService,
    [OBJECTS.GROUP]: GroupService,
    [OBJECTS.APPROVAL_WORKFLOW]: ApprovalWorkflowService,
    [OBJECTS.REPORT]: ReportsService,
    [OBJECTS.PLATFORM_SETTING]: PlatformSettingService,
    [OBJECTS.PROMPT]: PromptService,
    [OBJECTS.FOUNDATION_MODEL]: FoundationModelService,
    [OBJECTS.RAG]: RagService,
    [OBJECTS.PIPELINE]: PipelineService,
    [OBJECTS.CODE_REPO]: CodeRepoService,
    [OBJECTS.FEEDBACK_PORTAL]: FeedbackPortalService,
    [OBJECTS.TEST_SESSION]: TestSessionService,
    [OBJECTS.ANNOTATION_QUEUE]: AnnotationQueueService,
    [OBJECTS.MONITORING]: MonitoringService,
    [OBJECTS.RISK_ASSESSMENT]: RiskAssessmentService,
    [OBJECTS.DEPLOYMENT]: DeploymentService,
};
